import React, { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import {  useParams } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import {
    Container,
    Typography,
    Stack,
    CircularProgress,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TableContainer,
    Card,
    CardContent,
    Grid
} from '@mui/material';
import { tableCellClasses } from '@mui/material/TableCell';
import { Visible } from '../../../layouts/Visible'
import Page from '../../../components/Page';
import UserService from '../../../services/user_service'
import { useDispatch } from 'react-redux';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const useStyles = styled((theme) => ({
    root: {
        '& > *': {
            margin: theme.spacing(4),
            width: '25ch',
        },
    },
}));

const UserSubscription = () => {
    const params = useParams();
    const theme = useTheme();
    const classes = useStyles(theme);
    const [isLoading, setIsLoading] = useState(true);
    const dispatch = useDispatch();
    const [subscription, setSubscription] = useState({
        status: "",
        history: [],
        subscription_plan: "",
        price: "",
        subscription_plan_id: -1,
        days_left: -1,
    });

    function fetchSubscriptionData() {
        UserService.loadUserSubscription(params.user_id)
            .then((response) => response.data)
            .then((data) => setSubscription({
                status: data.status,
                subscription_plan: data.subscription_plan,
                price: data.price,
                subscription_plan_id: data.subscription_plan_id,
                days_left: data.days_left,
                history: data.history
            }))
            .then((data) => setIsLoading(false))
            .catch((error) => console.log(error))
    }
    useEffect(() => {
        dispatch({ type: 'USER', payload: { 'user': params.user_id } })
        fetchSubscriptionData();
    }, []);


    useEffect(() => {
        return () => {
            dispatch({ type: '', payload: { 'user': params.user_id } })
        }
    }, [])



    return (

        <Visible roles={["admin"]}>
            <Page title="User">
                <Container>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                        <Typography variant="h4" gutterBottom>
                            User subscription
                        </Typography>
                    </Stack>

                    <div>
                        {isLoading ? (
                            <CircularProgress className={classes.progress} />
                        ) : (
                            <Grid container spacing={3}>

                                <Grid item xs={9} sm={9} md={9}>
                                    <Card className={classes.root}>
                                        <CardContent>
                                            <Grid container spacing={4}>
                                                <Grid item xs={9} md={9} sm={9}>
                                                    <Typography className={classes.title} color="textSecondary" gutterBottom>
                                                        Subscription plan
                                                    </Typography>
                                                    <Typography variant="h5" component="h2">
                                                        {subscription.subscription_plan}
                                                    </Typography>

                                                </Grid>

                                            </Grid>
                                        </CardContent>
                                    </Card>
                                </Grid>
                                <Grid item xs={9} sm={9} md={9}>
                                    <Card className={classes.root}>
                                        <CardContent>
                                            <Grid container spacing={4}>
                                                <Grid item xs={3} md={3} sm={3}>
                                                    <Typography className={classes.title} color="textSecondary" gutterBottom>
                                                        Subscription status
                                                    </Typography>
                                                    <Typography variant="h5" component="h2">
                                                        {subscription.status}
                                                    </Typography>

                                                </Grid>
                                                <Grid item xs={3} md={3} sm={3}>
                                                    <Typography className={classes.title} color="textSecondary" gutterBottom>
                                                        Amount
                                                    </Typography>
                                                    <Typography variant="h5" component="h2">
                                                        ${subscription.price}/month
                                                    </Typography>
                                                </Grid>
                                                {subscription.days_left && <Grid item xs={3} md={3} sm={3}>
                                                    <Typography className={classes.title} color="textSecondary" gutterBottom>
                                                        Days left
                                                    </Typography>
                                                    <Typography variant="h5" component="h2">
                                                        {subscription.days_left}
                                                    </Typography>
                                                </Grid>}


                                            </Grid>
                                        </CardContent>
                                    </Card>
                                </Grid>

                                <Grid item xs={12} sm={12} md={9}>
                                    <Typography variant="h6" className={classes.title}>
                                        Subscription History
                                    </Typography>
                                    <TableContainer>
                                        <Table className={classes.table} aria-label="simple table">
                                            <TableHead className={classes.tableHead}>
                                                <StyledTableRow>
                                                    <StyledTableCell className={classes.tableCell}>Status</StyledTableCell>
                                                    <StyledTableCell align="right" className={classes.tableCell}>Start Date</StyledTableCell>
                                                    <StyledTableCell align="right" className={classes.tableCell}>End Date</StyledTableCell>
                                                </StyledTableRow>
                                            </TableHead>
                                            <TableBody>
                                                {subscription.history.map((history, index) => (
                                                    <StyledTableRow key={index} className={classes.tableRow}>
                                                        <StyledTableCell component="th" scope="row">
                                                            {history.status}
                                                        </StyledTableCell>
                                                        <StyledTableCell align="right">{history.start_date}</StyledTableCell>
                                                        <StyledTableCell align="right">{history.end_date}</StyledTableCell>
                                                    </StyledTableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                            </Grid>
                        )}
                    </div>
                </Container>
            </Page>
        </Visible>



    );
}
export default UserSubscription;